import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Ofwca} from "../../../shared/interface/ofwca";
import {Support} from "../../../shared/interface/support";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {IddTraining} from "../../../shared/interface/idd-training";
import {FormControl} from "@angular/forms";
import {ChartType} from "../../idd-trainings/idd-training-chart/idd-training-chart.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {OfwcaService} from "../../../shared/services/ofwca.service";
import {AuthService} from "../../../shared/services/auth.service";
import {SupportService} from "../../../shared/services/support.service";
import {takeUntil} from "rxjs/operators";
import {Partner} from "../../../shared/interface/partner";
import {Dictionary} from "../../../shared/interface/dictionary";
import {PARTNER_TAGS_PROFIT} from "../../../shared/services/dict.service";

@Component({
  selector: 'app-support-details-view',
  templateUrl: './support-details-view.component.html',
  styleUrls: ['./support-details-view.component.scss']
})
export class SupportDetailsViewComponent implements OnInit, OnDestroy {
  @Input() support: Observable<Support>;
  @Output() modifyClicked = new EventEmitter<any>();

  supportObject?: Support;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  constructor(
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private supportService: SupportService,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.support
      .pipe(takeUntil(this.destroyed$))
      .subscribe((support: Support) => {
        this.supportObject = support;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }
}
